import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import clsx from 'clsx';

import _ from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import Checkbox from '@material-ui/core/Checkbox';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import BobConfirmButton from '../../../../components/BobConfirmButton';
import BobCancelButton from '../../../../components/BobCancelButton';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import BobLoadingMask from '../../../../components/BobLoadingMask';

import * as BobActions from '../../../../actions/bobActions';
import * as BasAgentActions from '../../../../actions/basAgentActions';

import * as parentClasses from './ConfigureAgentPage.module.css';
import * as classes from './ConfigureNiagaraPage.module.css';

const ValidationSchema = Yup.object().shape({
    // eslint-disable-next-line no-useless-escape
    stationIp: Yup.string().matches(/^[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm, 'Invalid IP Address')
        .required(),
    port: Yup.number().typeError('Please input a number')
        .required(),
    lobbyPath: Yup.string()
        .required(),
    authType: Yup.string()
        .required(),
    niagaraUsername:     Yup.string(),
    niagaraPassword:     Yup.string(),
    requireHttps:        Yup.boolean(),
    requireCaValidation: Yup.boolean(),
    requireTLS:          Yup.boolean(),
    useCustomCa:         Yup.boolean()
});

const DEFAULT_FORM_VALUES = {
    stationIp:           '',
    port:                '',
    lobbyPath:           'obix',
    niagaraUsername:     '',
    niagaraPassword:     '',
    authType:            'Niagara4Digest',
    requireHttps:        false,
    requireCaValidation: false,
    requireTLS:          false,
    useCustomCa:         false
};

const ConfigureNiagaraPage = ({
    activeNavCompany,
    fetchBasAgent,
    history,
    selectedAgent,
    setBobLoading,
    setSelectedAgent,
    updateBasAgent,
    bobLoading,
    ...props
}) => {
    const [initialValues, setInitialValues] = useState({ ...DEFAULT_FORM_VALUES });

    useEffect(() => {
        if (selectedAgent) {
            const driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'Niagara');

            if (_.isNil(driverConfig)) return;

            const connection = _.get(driverConfig, 'connection', {});

            if (_.isEmpty(connection)) return;

            const formObject = { ...DEFAULT_FORM_VALUES };

            formObject.lobbyPath = _.get(connection, 'oBIXLobby', '');
            formObject.authType = _.get(connection, 'niagaraAuthType', '');
            formObject.stationIp = _.get(connection, 'stationIp', '');
            formObject.port = _.get(connection, 'stationPort', '');
            formObject.requireHttps = _.get(connection, 'requireHttps', false);
            formObject.requireCaValidation = _.get(connection, 'requireCaValidation', false);
            formObject.requireTLS = _.get(connection, 'requireTLS', false);
            formObject.useCustomCa = _.get(connection, 'useCustomCa', false);

            setInitialValues(formObject);
        }
    }, [selectedAgent]);

    const formik = useFormik({
        initialValues:      initialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const payload = {
                basType:    'Niagara',
                connection: {
                    niagaraAuthType:     values.authType,
                    oBIXLobby:           values.lobbyPath,
                    password:            values.niagaraPassword,
                    stationIp:           values.stationIp,
                    stationPort:         values.port,
                    userName:            values.niagaraUsername,
                    requireHttps:        values.requireHttps,
                    requireCaValidation: values.requireCaValidation,
                    requireTLS:          values.requireTLS,
                    useCustomCa:         values.useCustomCa
                }
            };

            let driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'Niagara');

            if (driverConfig) {
                payload.id = driverConfig.id;
            } else {
                driverConfig = _.find(selectedAgent.driverConfiguration, driver => driver.basType === 'NotConfigured');

                if (driverConfig) payload.id = driverConfig.id;
            }

            const updatedAgent = {
                driverConfiguration: [payload]
            };

            setSubmitting(true);

            try {
                setBobLoading('UpdateBasAgent');
                await updateBasAgent(activeNavCompany.id, selectedAgent.id, updatedAgent);
                const agent = await fetchBasAgent(selectedAgent.id);
                setSelectedAgent(agent);
                setSubmitting(true);
                setBobLoading('UpdateBasAgent');
                handleReroute();
            } catch (error) {
                setBobLoading('UpdateBasAgent');
                setSubmitting(false);
            }
        }
    });

    const handleReroute = () => {
        const path = '/v2/dashboard/iothub/manage';

        history.push({ pathname: path, search: history.location.search });
    };

    return (
        <React.Fragment>
            <div className={classes.InfoSettings}>
                <div className={classes.Title}>
                    Niagara Network Settings
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            The Niagara Settings provide the BAS Agent with the Niagara Station IP, the associated oBIX lobby, and the authentication details required to communicate with the Niagara system.
                        </p>
                        <p>
                            Please ensure that the host you are connecting to is one you trust.
                            If you do not trust the host, please DO NOT check this box as BOB will download any certificates presented by the host to allow a secure connection to be made between the host and the BAS Agent.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="stationIp"
                                name="stationIp"
                                label={<span>Niagara Station IP Address<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.stationIp}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.stationIp) && Boolean(formik.touched.stationIp)}
                                helperText={Boolean(formik.touched.stationIp) && formik.errors.stationIp}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="port"
                                name="port"
                                label={<span>Niagara HTTPS/HTTP Port<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.port}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.port) && Boolean(formik.touched.port)}
                                helperText={Boolean(formik.touched.port) && formik.errors.port}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="lobbyPath"
                                name="lobbyPath"
                                label={<span>oBIX Lobby Path<span className={classes.Required}> *</span></span>}
                                placeholder="Enter"
                                value={formik.values.lobbyPath}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.lobbyPath) && Boolean(formik.touched.lobbyPath)}
                                helperText={Boolean(formik.touched.lobbyPath) && formik.errors.lobbyPath}
                            />
                        </FormControl>
                        <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="authType"
                                classes={{
                                    root:    classes.SelectLabel,
                                    focused: classes.SelectLabel
                                }}
                                error={Boolean(formik.errors.authType) && Boolean(formik.touched.authType)}
                            >
                                Authentication Type<span className={classes.Required}> *</span>
                            </InputLabel>
                            <Select
                                value={formik.values.authType}
                                onChange={formik.handleChange}
                                className={classes.select}
                                inputProps={{
                                    name:   'authType',
                                    id:     'authType',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.authType) && Boolean(formik.touched.authType)}
                            >
                                <MenuItem value="HttpBasic" className={classes.selectMenuItem}>Http Basic</MenuItem>
                                <MenuItem value="NiagaraAXDigest" className={classes.selectMenuItem}>Niagara AX Digest</MenuItem>
                                <MenuItem value="Niagara4Digest" className={classes.selectMenuItem}>Niagara 4 Digest</MenuItem>
                            </Select>
                            {formik.touched.authType &&
                                formik.errors.authType && <FormHelperText className={classes.error}>{formik.errors.authType}</FormHelperText>}
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={classes.InfoCredentials}>
                <div className={classes.Title}>
                    Niagara Credentials
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            The Serial Number is unique to your Agent installation.
                            If you have one enter it now, or wait to enter it later.
                            Choose the time zone where the Agent will be installed.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="niagaraUsername"
                                name="niagaraUsername"
                                label={<span>Niagara Station Username</span>}
                                placeholder="Enter"
                                value={formik.values.niagaraUsername}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.niagaraUsername) && Boolean(formik.touched.niagaraUsername)}
                                helperText={Boolean(formik.touched.niagaraUsername) && formik.errors.niagaraUsername}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="niagaraPassword"
                                name="niagaraPassword"
                                label={<span>Niagara Password</span>}
                                placeholder="Enter"
                                value={formik.values.niagaraPassword}
                                onChange={formik.handleChange}
                                size="small"
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.NameLabel
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                className={classes.NameInput}
                                variant="outlined"
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.niagaraPassword) && Boolean(formik.touched.niagaraPassword)}
                                helperText={Boolean(formik.touched.niagaraPassword) && formik.errors.niagaraPassword}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={classes.InfoSecurity}>
                <div className={classes.Title}>
                    Advanced Security Settings
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        <p>
                            IMPORTANT Key2Act strongly recommends only using TLS v1.2+ to connect to the Niagara system.
                            Lower versions of TLS or SSL as well as unsecured HTTP connections can lead to system vulnerability.
                            Key2Act assumes no responsibility for use of insecure methods of data access.
                        </p>
                        <p>
                            It is best practice to require certificate validation.
                            However, if the system is using a self-signed certificate, this may not be possible.
                            If you are confident that the self-signed certificate is valid, or if there is no certificate in the case of HTTP access,
                            this may be unchecked to allow access. Key2Act always advises users to validate certificates.
                        </p>
                    </span>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.requireHttps}
                                        value="requireHttps"
                                        name="requireHttps"
                                        color="primary"
                                        onChange={formik.handleChange}
                                    />
                                }
                                label={'Require HTTPS'}
                                className={classes.checkboxLabel}
                            />
                            {
                                !formik.values.requireHttps &&
                                <FormHelperText className={classes.warning}><ErrorOutlineIcon className={classes.alignWarningIcon} /> {'WARNING - Disabling HTTPs requirement removes encryption and may lead to exposed data. Key2Act only recommends HTTPS.'}</FormHelperText>
                            }
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.requireCaValidation}
                                        value="requireCaValidation"
                                        name="requireCaValidation"
                                        color="primary"
                                        onChange={formik.handleChange}
                                    />
                                }
                                label={'Require Certificate Validation'}
                                className={classes.checkboxLabel}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.requireTLS}
                                        value="requireTLS"
                                        name="requireTLS"
                                        color="primary"
                                        onChange={formik.handleChange}
                                    />
                                }
                                label={'Require Secure protocols (TLS1.2+)'}
                                className={classes.checkboxLabel}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.useCustomCa}
                                        value="useCustomCa"
                                        name="useCustomCa"
                                        color="primary"
                                        onChange={formik.handleChange}
                                    />
                                }
                                label={'Use Custom Certificate Authority (CA)'}
                                className={classes.checkboxLabel}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className={parentClasses.InfoButtons}>
                <span>
                    <BobCancelButton
                        onClick={handleReroute}
                        disabled={formik.isSubmitting}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        onClick={formik.handleSubmit}
                        disabled={formik.isSubmitting}
                        className={classes.SaveButton}
                        label={'Save'}
                        iconSize={15}
                    />
                </span>
            </div>
            {
                bobLoading.includes('UpdateBasAgent') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    bobLoading: state.bob.bobLoading
});

const mapDispatchToProps = {
    ...BasAgentActions,
    ...BobActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigureNiagaraPage));
